import { render } from "./about.vue?vue&type=template&id=6d3a42c6&scoped=true&bindings={\"topImg\":\"data\",\"questionIcon1\":\"data\",\"questionIcon2\":\"data\",\"Icon1\":\"data\",\"Icon2\":\"data\",\"showMore\":\"data\"}"
import script from "./about.vue?vue&type=script&lang=js"
export * from "./about.vue?vue&type=script&lang=js"

import "./about.vue?vue&type=style&index=0&id=6d3a42c6&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-6d3a42c6"

export default script